import { Button } from '@mui/material';

const CARD_ACTION_BUTTON_SX = {
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.72rem',
  color: '#87C8E0',
  borderColor: 'rgba(135, 200, 224, 0.5)',
  py: 0.25,
  minHeight: 0,
  '&:hover': { borderColor: '#87C8E0', backgroundColor: 'rgba(135, 200, 224, 0.08)' },
};

// sx is merged rather than spread last, so a caller adding one layout rule does not silently drop
// the whole card-button look.
const CardActionButton = ({ sx, ...props }) => (
  <Button variant="outlined" size="small" sx={{ ...CARD_ACTION_BUTTON_SX, ...sx }} {...props} />
);

export default CardActionButton;
